import { faker } from '@faker-js/faker'

import { AdminTreatmentPropertyStatus, AdminUnitPropertyListItem } from '../../contracts/treatment'
import { asBuilder } from '../asBuilder'

export const getAdminUnitPropertyListItem = asBuilder((): AdminUnitPropertyListItem => {
  return {
    id: faker.string.uuid(),
    sequentialId: faker.number.int(),
    name: faker.lorem.word(),
    comparisonBaseValue: faker.number.int(),
    status: faker.helpers.enumValue(AdminTreatmentPropertyStatus),
  }
})
